export const feedbackFormUrl = 'client/feedback_form/';
